// Module
var code = "<div layout-fill layout=\"column\" layout-align=\"center stretch\">\n    <md-content flex layout=\"column\" class=\"mn-top-padding\">\n        <mn-certificate-item mn-item=\"::vm.certificate\" mn-unique></mn-certificate-item>\n    </md-content>\n</div>\n";
// Exports
module.exports = code;